<script>
  import Icon from "@iconify/svelte";

  let { onclose, title = "", width = "480px", children } = $props();
</script>

<!-- Mobile: full-screen slide-over from right -->
<div class="lg:hidden fixed inset-0 z-[110]" role="dialog" aria-label={title || "Details"}>
  <button
    class="absolute inset-0 bg-black/60 backdrop-blur-sm"
    onclick={onclose}
    aria-label="Close"
  ></button>
  <aside class="absolute right-0 top-0 bottom-0 w-full max-w-[480px] bg-zinc-900/95 backdrop-blur-xl border-l border-white/10 overflow-y-auto flex flex-col">
    <div class="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b border-white/10 bg-zinc-900/95 backdrop-blur-xl shrink-0">
      {#if title}
        <span class="text-sm font-semibold text-zinc-100 truncate mr-3">{title}</span>
      {:else}
        <span></span>
      {/if}
      <button
        class="flex h-8 w-8 items-center justify-center rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 transition-colors shrink-0"
        onclick={onclose}
      >
        <Icon icon="mdi:close" class="w-5 h-5" />
      </button>
    </div>
    <div class="flex-1 p-5 sm:p-6">
      {@render children()}
    </div>
  </aside>
</div>

<!-- Desktop: fixed right panel -->
<aside
  class="hidden lg:block fixed right-0 top-[88px] bottom-0 border-l border-white/10 bg-zinc-900/95 backdrop-blur-xl overflow-y-auto z-50"
  style="width:{width}"
>
  <button
    class="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-lg text-zinc-400 hover:text-white hover:bg-white/10 transition-colors z-10"
    onclick={onclose}
  >
    <Icon icon="mdi:close" class="w-5 h-5" />
  </button>
  <div class="p-6 pr-14">
    {@render children()}
  </div>
</aside>
